<template>
  <div class="text-[14px] leading-[20px] text-gray-800">
    <p v-if="renewalDate">
      If you cancel, your membership will remain active until
      <span class="font-medium">{{ renewalDate }}</span
      >. After that date:
    </p>

    <p v-else>If you cancel your membership:</p>

    <div class="mt-5 rounded-[12px] border border-[#f2f0ee] bg-[#f9f9fa] p-5">
      <ul class="flex flex-col gap-3.5">
        <li
          v-for="(bullet, index) in cancelContent.bullets"
          :key="index"
          class="flex gap-2.5"
        >
          <span aria-hidden="true">&bull;</span>
          <span>{{ bullet }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { PlanStatus } from '@/shared/graphql/legacy/generated'
import { formatTimestamp } from '@/shared/utils/datetime'
import { useBillingStore } from '@/features/billing/store'

import { cancelContent } from '../content'

const billingStore = useBillingStore()

const renewalDate = computed(() => {
  if (billingStore.billing?.plan.status !== PlanStatus.Active) return ''
  const date = billingStore.billing?.plan.dateInfo?.date
  return date ? formatTimestamp(date, { formatString: 'LLLL d, yyyy' }) : ''
})
</script>
